// extracted by mini-css-extract-plugin
export default {"header":"Header_header__ypesT","main-image":"Header_main-image__4sZGt"};